var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5C6.1125 0.5 0.5 6.1125 0.5 13C0.5 19.8875 6.1125 25.5 13 25.5C19.8875 25.5 25.5 19.8875 25.5 13C25.5 6.1125 19.8875 0.5 13 0.5ZM17.2 15.875C17.5625 16.2375 17.5625 16.8375 17.2 17.2C17.0125 17.3875 16.775 17.475 16.5375 17.475C16.3 17.475 16.0625 17.3875 15.875 17.2L13 14.325L10.125 17.2C9.9375 17.3875 9.7 17.475 9.4625 17.475C9.225 17.475 8.9875 17.3875 8.8 17.2C8.4375 16.8375 8.4375 16.2375 8.8 15.875L11.675 13L8.8 10.125C8.4375 9.7625 8.4375 9.1625 8.8 8.8C9.1625 8.4375 9.7625 8.4375 10.125 8.8L13 11.675L15.875 8.8C16.2375 8.4375 16.8375 8.4375 17.2 8.8C17.5625 9.1625 17.5625 9.7625 17.2 10.125L14.325 13L17.2 15.875Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d301b23b57930c34918b4cec0f80de2f.svg";
export { ForwardRef as ReactComponent };